import Router from 'vue-routes-generator'
import Main from './main'
export default {
	install: () => {
		Router.route('/main').child('objetivos-agentes', {
			name: 'Objetivos agentes',
			component: Main
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/objetivos-agentes/vue/index.js